import React from 'react';
import PropTypes from 'prop-types';

import  { lazy } from 'react';
import { Link as ReactLink } from 'react-router-dom';

const NextLinkComponent = lazy(() => import('next/link'));

const Link = ({
   children,
   isNextApp,
   href,
   className = '',
   prefetch,
   onClick = () => {},
   styles,
   target,
}) => {
   if(!href){
      return (
         <>
            {children}
         </>
      )
   }
   if(isNextApp){
      return (
         <NextLinkComponent
            href={ href }
            className={ className }
            prefetch={ prefetch }
            onClick={ onClick }
            style={ styles }
            target={ target }
         >
            {children}
         </NextLinkComponent>
      )
   }
   return (
      <ReactLink
         to={ href }
         className={ className }
         style={ styles }
         target={ target }
      >
         {children}
      </ReactLink>
   )
}



Link.propTypes = {
   children: PropTypes.any,
   isNextApp: PropTypes.string,
   className: PropTypes.string,
   prefetch: PropTypes.bool,
   href: PropTypes.string,
   onClick: PropTypes.func,
   styles: PropTypes.string,
   target: PropTypes.string,
};

export default Link;
